module.exports = __webpack_public_path__ + "static/media/0029_LES_MURS_HARMONIE_3.de22f4c9.png";